// extracted by mini-css-extract-plugin
export default {"skeleton-chips-group":"atRYDg","skeleton-chips-group_wrap":"RvJoZu"};